module.exports = __webpack_public_path__ + "static/media/YM24_0.018295f9.jpg";